import { useCallback } from "react";

export const useSaveFileToSessionStorage = () => {
  const saveFile = useCallback((key: string, file: File | null) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result) {
        sessionStorage.setItem(key, reader.result.toString());
      }
    };
    reader.readAsDataURL(file);
  }, []);

  return saveFile;
};
